import 'dayjs/locale/es'
import dayjs from 'dayjs'

let DayTime = dayjs


export default DayTime